export default __webpack_public_path__ + "static/media/paypal.76bc0d37.svg";